module.exports = __webpack_public_path__ + "static/media/buttonArrow.3dce6102.svg";